import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="hero-surface min-h-screen flex flex-col items-center justify-center px-6 text-center">
      <p className="text-7xl md:text-9xl font-extrabold text-gradient font-display">404</p>
      <h1 className="mt-4 text-2xl md:text-3xl font-bold text-ink">{t('notFound.title')}</h1>
      <p className="mt-3 max-w-md text-slatex-600">
        {t('notFound.text')}
      </p>
      <Link to="/" className="btn-primary mt-8">
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
        {t('notFound.back')}
      </Link>
    </div>
  );
};

export default NotFound;
